export const MODAL_COMPONENTS = {
  QuarterRange: defineAsyncComponent(() => import('./QuarterRange.vue')),
  SendInvoice: defineAsyncComponent(() => import('./SendInvoice.vue')),
  accept: defineAsyncComponent(() => import('./Accept.vue')),
  'bulk-planner': defineAsyncComponent(() => import('./BulkPlanner.vue')),
  completeEntry: defineAsyncComponent(() => import('./CompleteEntry.vue')),
  confirm: defineAsyncComponent(() => import('./Confirm.vue')),
  'date-range': defineAsyncComponent(() => import('./DateRange.vue')),
  endOfDay: defineAsyncComponent(() => import('./EndOfDay.vue')),
  form: defineAsyncComponent(() => import('./Form.vue')),
  proposal: defineAsyncComponent(() => import('./Proposal.vue')),
  'time-slots': defineAsyncComponent(() => import('./TimeSlots.vue')),
  'cancel-booking': defineAsyncComponent(() => import('./CancelBooking.vue')),
  'year-select': defineAsyncComponent(() => import('./YearSelect.vue')),
  'data': defineAsyncComponent(() => import('./Data.vue')),
}
